import { ProductCategoryMappingsDict } from "../types/serp"
import { toDict } from "../utils/array"

export const toCustomCategoriesDict = (
  customCategories: any
): ProductCategoryMappingsDict =>
  customCategories
    ? toDict(customCategories, (x: any) => x.code?.toLowerCase())
    : {}

export const mergeBrandCodes = (brand: any, secondaryBrands: any) =>
  brand
    ? [
        brand.data.code,
        ...(secondaryBrands?.map((x: any) => x.code).filter((x: any) => x) ??
          []),
      ]
    : undefined
